export default class InfiniteScroll {

    static observe(init = false) {
        if (InfiniteScroll.observer) {
            InfiniteScroll.observer.disconnect();
        }
        let lastRecord = document.querySelector('#last_record');
        const infiniteScroll = document.querySelector('[data-infinite-scroll]');
        InfiniteScroll.observer = new IntersectionObserver((entries) => {
            entries.forEach((entry) => {
                if (! JSON.parse(infiniteScroll.dataset.infiniteScroll)) {
                    return;
                }

                if (entry.isIntersecting) {
                    window.Livewire?.emit('infinite-scroll:load');
                }
            });
        });

        const getLastRecord = () => {
            lastRecord = document.querySelector('#last_record');
        }

        window.addEventListener('infinite-scroll:loaded', getLastRecord);

        if (infiniteScroll && lastRecord) {
            InfiniteScroll.observer.observe(lastRecord);
        }
        if (init) {
            const targetInitScroll = infiniteScroll.querySelector('[data-scroll-target]');
            if (targetInitScroll) {
                targetInitScroll.scrollIntoView();
            }
        }
    }

    static livewireRebind() {
        window.Livewire?.hook('message.processed', () => {
            InfiniteScroll.observe();
        });
    }
}
